module.exports = __webpack_public_path__ + "static/finance-students-learn-secrets-of-the-trade-d6d011be50465c246423956dd45597cf.jpg";